import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { fetchInvoiceHistoryAPI } from "../../../../shared/hooks/useFetchPaymentHistory";

type InvoiceHistoryState = {
  invoiceHistoryData: any;
  loading: boolean;
  error: string | null;
};

const initialState: InvoiceHistoryState = {
  invoiceHistoryData: null,
  loading: false,
  error: null,
};

export const getInvoiceHistory = createAsyncThunk(
  "invoice/getInvoiceHistory",
  async (billingAccountNumber: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let url = API_URLS['invoiceHistoryUrl_QA_URL']
      const response = await fetchInvoiceHistoryAPI(
        {
          [url]: billingAccountNumber,
        },
        headers
      );

      return response.data;
    } catch (error: any) {
      throw error
    }
  }
);

const invoiceHistorySlice = createSlice({
  name: "invoiceHistory",
  initialState,
  reducers: {
    clearInvoiceHistorySlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getInvoiceHistory.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.invoiceHistoryData = action.payload;
        }
      )
      .addCase(getInvoiceHistory.rejected, (state, action) => {
        state.loading = false;
        state.invoiceHistoryData = null;
      });
  },
});

export const { clearInvoiceHistorySlice } = invoiceHistorySlice.actions;

export default invoiceHistorySlice.reducer;
